import { Button, Card, Tab, Alert } from "react-bootstrap";
import { Form, Row, Col } from "react-bootstrap";
import { Chart } from 'react-google-charts';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from "axios";
import { useState, useEffect } from "react";
import { SpinnerModal } from "../Util";

export default function AdminAdd() {
    const ADMIN_BASE_URL = process.env.REACT_APP_ADMIN_BASE_URL;
    const GETALL_USER_ROLE_URL = process.env.REACT_APP_GETALL_USER_ROLE_URL

    const allUsers = [
        ["First Name", "Last Name", "Email", "User Role", "Default Site"],
        // ["Path", "Palsamy", "path@dominotech.net", "Site Administrator", "PA Mililtary Museum"],
        // [userProfile ? userProfile.name : '', userProfile ? userProfile.name : '', userProfile ? userProfile.username : '', "Site Administrator", "PA Mililtary Museum"]
    ]
    // Retrieve all User from Az AD
    useEffect(() => {

        const url = ADMIN_BASE_URL + GETALL_USER_ROLE_URL
        console.log(url);

        if (url)
            axios.post(url)
                .then(response => {
                    console.log(response);
                    const users = response.data;
                    users.forEach(element => {
                        console.log(element.userPrincipalName)
                        allUsers.push([element.firstName, element.lastName, element.userPrincipalName, element.role, element.defaultSite]);
                    });
                })

                .catch(error => { console.error(error) });
    }, []);
    // const p = localStorage.getItem('userProfile');
    // const userProfile = p ? JSON.parse(p) : '';


    const options = {
        showRowNumber: true,
        pageSize: 20
    };

    const addUserSchema = Yup.object({
        firstName: Yup.string().min(3, 'Too Short').max(50, 'Too Long').required('First Name is required'),
        lastName: Yup.string().min(3, 'Too Short').max(50, 'Too Long').required('Last Name is required'),
        email: Yup.string().email('Invalid email').required('Email is required'),
        role: Yup.string().required('Role is required')
    })
    const userForm = useFormik({
        initialValues: {
            firstName: "",
            lastName: "",
            email: "",
            role: "",
            defaultSite: ""
        },
        validationSchema: addUserSchema
    })
    const userpwd = 'xWwvJ]6NMw+bWH-';
    const newUserData = {
        accountEnabled: true,
        displayName: '',
        mailNickname: '',
        userPrincipalName: '',
        passwordProfile: {
            forceChangePasswordNextSignIn: true,
            password: userpwd
        }
    };

    const [isSpinner, setSpinner] = useState(false);
    const showSpinner = () => { setSpinner(true) }
    const hideSpinner = () => { setSpinner(false) }
    const [showAlert, setShowAlert] = useState(false);
    const [alertHeading, setAlertHeading] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const autoDismissDuration = 60000;
    const dismissAlert = () => {
        setShowAlert(false);
    };

    // const [countdown, setCountdown] = useState(60);
    // // Function to update the countdown every second
    // useEffect(() => {
    //     let countdownInterval;
    //     if (showAlert) {
    //         countdownInterval = setInterval(() => {
    //             setCountdown((prevCountdown) => prevCountdown - 1);
    //         }, 1000);
    //     }
    //     // Clear the interval when the component unmounts or the alert is dismissed
    //     return () => clearInterval(countdownInterval);
    // }, []);

    // // Function to format seconds as "X seconds"
    // const formatRemainingTime = () => {
    //     return `${countdown} second${countdown !== 1 ? 's' : ''}`;
    // };

    // // Auto-dismiss the alert after the specified duration
    // useEffect(() => {
    //     if (countdown <= 0) {
    //         dismissAlert();
    //     }
    // }, [countdown]);



    const addUser = () => {
        showSpinner();
        const displayName = userForm.values.firstName + ' ' + userForm.values.lastName;
        newUserData.displayName = displayName;
        newUserData.userPrincipalName = userForm.values.email;
        const nickName = newUserData.userPrincipalName.substring(0, userForm.values.email.indexOf('@'));
        newUserData.mailNickname = nickName
        console.log(newUserData);
        const adminADUrl = process.env.REACT_APP_AAD_CREATE_USER_URL;
        console.log('url ' + adminADUrl);
        // Store Authorization data before register to AD
        const authDBUrl = process.env.REACT_APP_ADD_AUTH_USER_ROLE_URL;
        let userAddForAuthorization = false;
        if (authDBUrl) {
            axios.post(authDBUrl, userForm.values)
                .then((response) => {
                    console.log('Authorization data added: ' + response.data);

                    if (adminADUrl)
                        axios.post(adminADUrl, newUserData)
                            .then((response) => {
                                console.log(response.status, response.data);
                                hideSpinner();
                                setShowAlert(true);
                                setAlertHeading('User Added!');
                                setAlertMessage(`User has been Added to PHMC Reporting, Please share the password with the user. onetime password for email ${newUserData.userPrincipalName} is ${newUserData.passwordProfile.password}`);
                                setTimeout(dismissAlert, autoDismissDuration);
                                userForm.handleReset();
                            })
                            .catch((error) => {
                                console.log(error);
                                // Call Auth api to remove added in authorization table
                                hideSpinner();
                            })
                })
                .catch((error) => {
                    console.error(error);
                    hideSpinner();
                })
        }


    }

    return (
        <>
            {
                showAlert ? (
                    <Alert variant="success" onClose={() => setShowAlert(false)} dismissible>
                        <Alert.Heading>{alertHeading} </Alert.Heading>
                        <p>{alertMessage}  </p>
                        <p>
                            This alert will automatically dismiss in ${autoDismissDuration} seconds.
                        </p>
                    </Alert>

                ) : (<div />)}

            <Form className="main-content">
                <Card>
                    <Row className="mb-0 main-content">
                        <Form.Group as={Col} >
                            <Form.Label>First Name</Form.Label>
                            <Form.Control name="firstName" value={userForm.values.firstName}
                                onChange={userForm.handleChange}
                                isInvalid={userForm.touched.firstName && userForm.errors.firstName} />
                        </Form.Group>
                        <Form.Group as={Col} >
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control name="lastName" value={userForm.values.lastName}
                                onChange={userForm.handleChange}></Form.Control>
                        </Form.Group>
                        <Form.Group as={Col} >
                            <Form.Label>User email</Form.Label>
                            <Form.Control name="email" value={userForm.values.email}
                                onChange={userForm.handleChange} />
                        </Form.Group>
                    </Row>
                    <Row className="mb-0 main-content">
                        <Form.Group as={Col} >
                            <Form.Label>Role</Form.Label>
                            <Form.Select defaultValue="" name="role" required value={userForm.values.role}
                                onChange={userForm.handleChange}>
                                <option value="">Select</option>
                                <option value="SITE_ADMIN">Site Administrator</option>
                                <option value="APPROVER">Approver</option>
                                <option value="DATA_ENTRY">Data Entry</option>
                                <option value="APPLICATION_MANAGER">Application Manager</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group as={Col} >
                            <Form.Label>Default Site Name</Form.Label>
                            <Form.Select defaultValue="" name="defaultSite" required value={userForm.values.defaultSite}
                                onChange={userForm.handleChange}>
                                <option value="">Select</option>
                                <option>ANTHRACITE HERITAGE</option>
                                <option>BRANDYWINE BATTLEFIELD</option>
                                <option>BUSHY </option>
                                <option>CONRAD W</option>
                                <option>CORNWALL</option>
                                <option>DANIEL B</option>
                                <option>DRAKE WELL</option>
                                <option>ECKLEY MINERS' VLGE</option>
                                <option>EPHRATA CLOISTER</option>
                                <option>ERIE MARITIME</option>
                                <option>FORT PITT</option>
                                <option>GRAEME </option>
                                <option>HOPE</option>
                                <option>JOSEPH P</option>
                                <option>LANDIS VALLEY</option>
                                <option>OLD ECONOMY</option>
                                <option>PENNSBURY</option>
                                <option>PA LUMBER MUSEUM</option>
                                <option>PA MILITARY MUSEUM</option>
                                <option>RAILROAD MUSEUM</option>
                                <option>SOMERSET</option>
                            </Form.Select>
                        </Form.Group>
                        <Col />
                    </Row>
                    <Row className="mb-0 main-content">

                        <Form.Group as={Col} >
                            <Button onClick={addUser}> Add User</Button>
                        </Form.Group>


                    </Row>
                    <Row className="mb-0 main-content">
                        <Chart
                            width={'100%'}
                            height={'100%'}
                            chartType="Table"
                            loader={<div>Loading Chart</div>}
                            data={allUsers}
                            options={options}

                            rootProps={{ 'data-testid': '1' }}
                        />
                    </Row>
                </Card>
                <SpinnerModal show={isSpinner} onHide={() => hideSpinner} />
            </Form >
        </>
    );
}
